import { render } from "./takeOutSpecialOrderModel.vue?vue&type=template&id=6a5b4d17"
import script from "./takeOutSpecialOrderModel.vue?vue&type=script&lang=js"
export * from "./takeOutSpecialOrderModel.vue?vue&type=script&lang=js"

import "./takeOutSpecialOrderModel.vue?vue&type=style&index=0&id=6a5b4d17&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__